import React, { useState, useEffect } from 'react';
import { getVideos } from "../api/videoApi";
import { getImages } from "../api/imageApi";
import { getPdfs } from "../api/pdfApi";
import Footer from './Footer';

const OurTeam = () => {
  const [media, setMedia] = useState({ videos: [], images: [], pdfs: [] });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const category = "Our Team";

  useEffect(() => {
    const fetchMedia = async () => {
      try {
        const videos = await getVideos(category);
        const images = await getImages(category);
        const pdfs = await getPdfs(category);
        setMedia({ videos, images, pdfs });
      } catch (err) {
        console.error("Error fetching team media:", err);
        setError("Failed to load team media.");
      } finally {
        setLoading(false);
      }
    };
    fetchMedia();
  }, []);

  if (loading) return <p className="text-center text-gray-600">Loading team media...</p>;
  if (error) return <p className="text-center text-red-500">{error}</p>;

  return (
    <div className="w-full font-sans">
      {/* Full-width Hero Image Section */}
      <div className="relative w-full m-h-screen mt-0">
        <img
          src="/Hero-OurTeam.jpeg"
          // className="w-full h-[70vh] object-cover"
          // className="w-full object-cover object-center h-[45vh] sm:h-[55vh] md:h-[65vh] lg:h-[75vh] xl:h-[85vh]"
          className="w-full h-auto object-cover object-center"
        />
        <div className="absolute inset-x-0 bottom-0 sm:bottom-4 left-0 right-0 text-white text-center px-6 sm:px-12">
          <div className="bg-black bg-opacity-50 p-2 sm:p-6 rounded-lg inline-block">
            <h1 className="text-xl sm:text-5xl font-bold drop-shadow-lg">Our Team</h1>
          </div>
        </div>
      </div>
      <div className="max-w-6xl mx-auto px-6 py-12 flex-grow">

        {/* Display Media Sections */}
        <div className="space-y-12">
          {/* Videos Section */}
          {/* <SectionCard title="Team Videos">
          {media.videos.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {media.videos.map((video) => (
                <MediaCard key={video._id} title={video.title}>
                  <video className="w-full rounded-md shadow-lg" controls>
                    <source src={video.fileUrl ? `http://localhost:5555${video.fileUrl}` : video.url} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </MediaCard>
              ))}
            </div>
          ) : (
            <NoContent text="No team videos found." />
          )}
        </SectionCard> */}

          {/* Images Section */}
          <SectionCard title="">
            {/* {media.images.length > 0 ? (
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                {media.images.map((image) => (
                  <MediaCard key={image._id}>          
                    <div className="w-full aspect-w-1 aspect-h-1 flex items-center justify-center bg-gray-100 overflow-hidden rounded-md shadow-md hover:scale-105 transform transition-all duration-300">
                      <img
                        className="w-full h-full object-cover object-center"                     
                        src={image.fileUrl} 
                        alt={image.title || "Uploaded Image"}
                        onError={(e) => (e.target.src = "/default-placeholder.jpg")}
                      />
                    </div>
                    <h3 className="text-lg text-black font-semibold mt-4 text-gray-900 text-center">
                      {image.title || "Unnamed Member"}
                    </h3>
                  </MediaCard>
                ))}
              </div>
            ) : (
              <NoContent text="No team images found." />
            )} */}
            {media.images.length > 0 ? (
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                {media.images.map((image) => {
                  console.log("image.imageUrl:", image.imageUrl);
                  console.log("image.fileUrl: ", image.fileUrl);
                  return (
                    <MediaCard key={image._id}>
                      <div className="w-full aspect-w-1 aspect-h-1 flex items-center justify-center bg-gray-100 overflow-hidden rounded-md shadow-md hover:scale-105 transform transition-all duration-300">
                        <img
                          className="w-full h-full object-cover object-center"
                          src={(image.imageUrl || image.fileUrl).replace(/^https?:\/\/[^/]+/, '')}
                          alt={image.title || "Team member"}
                          onError={(e) => (e.currentTarget.src = "/default-placeholder.jpg")}
                        />
                      </div>
                      <h3 className="text-lg font-semibold mt-4 text-gray-900 text-center">
                        {image.name || "Unnamed Member"}
                      </h3>
                      <h3 className="text-md font-semibold mt-4 text-gray-900 text-center">
                        {image.title || "Unnamed Member"}
                      </h3>
                    </MediaCard>
                  );
                })}
              </div>
            ) : (
              <NoContent text="No team images found." />
            )}

          </SectionCard>

          {/* PDFs Section */}
          {/* <SectionCard title="Team PDFs">
          {media.pdfs.length > 0 ? (
            <ul className="space-y-2">
              {media.pdfs.map((pdf) => (
                <li key={pdf._id}>
                  <a
                    href={pdf.fileUrl ? `http://localhost:5555${pdf.fileUrl}` : pdf.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-purple-700 hover:underline hover:text-purple-900 transition duration-300"
                  >
                    {pdf.title || "Untitled PDF"}
                  </a>
                </li>
              ))}
            </ul>
          ) : (
            <NoContent text="No team PDFs found." />
          )}
        </SectionCard> */}
        </div>
      </div>
      <Footer isFullFooter={false} />
    </div>
  );
};

/* Section Wrapper */
const SectionCard = ({ title, children }) => (
  <section className="bg-white border border-gray-200 shadow-lg rounded-xl p-6">
    <h2 className="text-3xl font-semibold text-gray-900 mb-4">{title}</h2>
    {children}
  </section>
);

/* Card for Media Items */
// const MediaCard = ({ title, children }) => (
//   <div className="bg-gray-50 rounded-lg p-4 border border-gray-300 shadow-md">
//     <h3 className="text-lg font-medium text-gray-800 mb-2">{title}</h3>
//     {children}
//   </div>
// );

/* Card for Media Items */
const MediaCard = ({ title, children }) => (
  <div className="bg-gray-50 rounded-lg p-4 border border-primary shadow-md hover:bg-primary/10 hover:text-white transition-all duration-300">
    <h3 className="text-lg font-medium text-gray-800 mb-2">{title}</h3>
    {children}
  </div>
);


/* Placeholder for Empty Sections */
const NoContent = ({ text }) => <p className="text-gray-500">{text}</p>;

export default OurTeam;

// import React, { useState, useEffect } from "react";
// import { getVideos } from "../api/videoApi";
// import { getImages } from "../api/imageApi";
// import { getPdfs } from "../api/pdfApi";
// import { getLinks } from "../api/linkApi";
// import { getBios } from "../api/bioApi"; // ✅ Import Bios API

// function OurTeam() {
//   const [videos, setVideos] = useState([]);
//   const [images, setImages] = useState([]);
//   const [pdfs, setPdfs] = useState([]);
//   const [links, setLinks] = useState([]);
//   const [bios, setBios] = useState([]); // ✅ Add Bios State
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   // useEffect(() => {
//   //   const fetchMedia = async () => {
//   //     try {
//   //       console.log("🔵 Fetching media for Our Team...");

//   //       const [videoData, imageData, pdfData, linkResponse, bioData] = await Promise.all([
//   //         getVideos("Our Team"),
//   //         getImages("Our Team"),
//   //         getPdfs("Our Team"),
//   //         getLinks("Our Team"),
//   //         getBios("Our Team"), // ✅ Fetch bios
//   //       ]);

//   //       console.log("🟢 API Response - Images:", imageData);
//   //       console.log("🟢 API Response - Videos:", videoData);
//   //       console.log("🟢 API Response - PDFs:", pdfData);
//   //       console.log("🟢 API Response - Links:", linkResponse);
//   //       console.log("🟢 API Response - Bios:", bioData); // ✅ Log bios

//   //       setVideos(videoData);
//   //       setImages(imageData);
//   //       setPdfs(pdfData);
//   //       setLinks(linkResponse);
//   //       setBios(bioData); // ✅ Store bios
//   //     } catch (err) {
//   //       console.error("❌ Error fetching media", err);
//   //       setError("Failed to load media.");
//   //     } finally {
//   //       setLoading(false);
//   //     }
//   //   };

//   //   fetchMedia();
//   // }, []);

//   const mergeBiosWithImages = (images, bios) => {
//     return images.map((image) => {
//       const matchingBio = bios.find((bio) => bio.imageId === image._id);
//       return {
//         ...image,
//         bio: matchingBio ? matchingBio.bio : "No bio available.",
//       };
//     });
//   };

//   useEffect(() => {
//     const fetchMedia = async () => {
//       try {
//         const [videoData, imageData, pdfData, linkResponse] = await Promise.all([
//           getVideos("Our Team"),
//           getImages("Our Team"),
//           getPdfs("Our Team"),
//           getLinks("Our Team"),
//           getBios("Our Team"),  // ✅ Fetch bios
//         ]);

//         // console.log("🟢 API Response - Bios:", bioData);

//         const mergedImages = mergeBiosWithImages(imageData, bioData); // ✅ Merge bios with images

//         setVideos(videoData);
//         setImages(mergedImages);
//         setPdfs(pdfData);
//         setLinks(linkResponse);
//       } catch (err) {
//         console.error("❌ Error fetching media", err);
//         setError("Failed to load media.");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchMedia();
//   }, []);


//   if (loading) return <p className="text-center text-gray-600">Loading team media...</p>;
//   if (error) return <p className="text-center text-red-500">{error}</p>;

//   return (
//     <div className="max-w-6xl mx-auto px-6 py-12">
//       {/* Page Title & Intro */}
//       <div className="text-center mb-12">
//         <h1 className="text-5xl font-bold text-purple-800">Our Team</h1>
//         <p className="text-lg text-gray-600 mt-3 max-w-2xl mx-auto">The Team of The Owen Lab</p>
//       </div>

//       {/* Team Members Section (Image + Bio) */}
//       {/* <SectionCard title="Meet Our Team">
//         {images.length > 0 ? (
//           <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
//             {images.map((image) => {
//               const bio = bios.find((b) => b.imageId === image._id)?.bio || "No bio available."; // ✅ Match bio to image

//               return (
//                 <MediaCard key={image._id} title={image.title}>
//                   <img
//                     className="w-full h-auto rounded-md shadow-md object-cover"
//                     src={image.fileUrl ? `http://localhost:5555${image.fileUrl}` : image.url}
//                     alt={image.title || "Team Member"}
//                     onError={(e) => (e.target.src = "/default-placeholder.png")}
//                   />
//                   <p className="text-gray-700 mt-2">{bio}</p>
//                 </MediaCard>
//               );
//             })}
//           </div>
//         ) : (
//           <NoContent text="No team members found." />
//         )}
//       </SectionCard> */}
//       <SectionCard title="Our Team Members">
//         {images.length > 0 ? (
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
//             {images.map((image) => (
//               <div key={image._id} className="bg-white shadow-lg rounded-lg overflow-hidden">
//                 <img
//                   className="w-full h-64 object-cover rounded-md shadow-md"
//                   src={image.fileUrl ? `http://localhost:5555${image.fileUrl}` : image.url}
//                   alt={image.title || "Team Member"}
//                 />

//                 <div className="p-4 text-center">
//                   <h3 className="text-xl font-semibold text-gray-900">{image.title || "Unnamed Member"}</h3>
//                 </div>
//               </div>
//             ))}
//           </div>
//         ) : (
//           <NoContent text="No team members found." />
//         )}
//       </SectionCard>

//     </div>
//   );
// }

// /* Section Wrapper */
// const SectionCard = ({ title, children }) => (
//   <section className="bg-white border border-gray-200 shadow-lg rounded-xl p-6">
//     <h2 className="text-3xl font-semibold text-gray-900 mb-4">{title}</h2>
//     {children}
//   </section>
// );

// /* Card for Media Items */
// const MediaCard = ({ title, children }) => (
//   <div className="bg-gray-50 rounded-lg p-4 border border-gray-300 shadow-md">
//     <h3 className="text-lg font-medium text-gray-800 mb-2">{title}</h3>
//     {children}
//   </div>
// );

// /* Placeholder for Empty Sections */
// const NoContent = ({ text }) => <p className="text-gray-500">{text}</p>;

// export default OurTeam;


